export enum EventList {
    unauthenticated='unauthenticated',
    unauthorized='unauthorized',
}